import {Injectable} from '@angular/core';
import {AnnouncementModel} from '../models/announcement-model';
import {HttpServiceBase} from '../../../core/services/http-service-base';

@Injectable()
export abstract class IAnnouncementsHttpService extends HttpServiceBase{

    public abstract getAnnouncements(): Promise<AnnouncementModel[]>;
    public abstract confirmAnnouncements(announcements: AnnouncementModel[]): Promise<void>;

}
